import { render, staticRenderFns } from "./Treasure.vue?vue&type=template&id=55e4c51e&scoped=true"
import script from "./Treasure.vue?vue&type=script&lang=js"
export * from "./Treasure.vue?vue&type=script&lang=js"
import style0 from "./Treasure.vue?vue&type=style&index=0&id=55e4c51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e4c51e",
  null
  
)

export default component.exports